import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { Box, Button, Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../hook/Translation';

export default function HeroSlider({ data }) {
    const { t } = useTranslation();
    return (
        <Swiper spaceBetween={50} slidesPerView={1} loop height={'100%'} modules={[Autoplay, Pagination]} pagination={{ clickable: true }} navigation={true} autoplay={{ delay: 4000, disableOnInteraction: false }}>
            {
                data.map((slider, index) => (
                    <SwiperSlide key={index}>
                        <Box className="slide" sx={{ height: '100%' }}>
                            <Box sx={{ height: '100%', width: '100%', marginX: 'auto', backgroundColor: 'rgb(30, 53, 61)', display: { lg: 'flex', xs: 'none' }, justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
                                <Grid container spacing={8} sx={{ zIndex: 1, width: { md: '85%', xs: '90%' } }}>
                                    <Grid size={12} zIndex={2}>
                                        <Grid container spacing={2}>
                                            <Grid size={12}>
                                                <Typography variant="h1" component={'h1'} fontSize={{ md: '64px', xs: '2rem' }} color='text.primary' fontWeight={'bold'} fontFamily={'DanmarkURW'}>
                                                    {slider?.title}
                                                </Typography>
                                            </Grid>
                                            <Grid size={12}>
                                                <Typography variant="body1" component={'p'} fontSize={{ md: '24px', xs: '1.125rem' }} color='text.primary' sx={{ whiteSpace: 'pre-wrap' }}>
                                                    {slider?.description}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid size={{ md: 4, xs: 12 }} zIndex={2}>
                                        <Grid container spacing={2}>
                                            <Grid size={{ md: 6, xs: 12 }}>
                                                <Button
                                                    fullWidth
                                                    component={Link}
                                                    to={`https://wa.me/+383049909090?text=${encodeURIComponent(slider.bookUrl)}`}
                                                    target="_blank"
                                                    variant='contained'
                                                    className='borderRadiusFlat borderWidth2 buttonPaddingY10 placeBorder'
                                                    sx={{ borderColor: 'text.primary', height: '50px', fontSize: '18px', boxShadow: 'none' }}
                                                >
                                                    {t('book_now')}
                                                </Button>
                                            </Grid>
                                            {
                                                slider.learnUrl &&
                                                <Grid size={{ md: 6, xs: 12 }}>
                                                    <Button
                                                        fullWidth
                                                        component={Link}
                                                        to={slider.learnUrl}
                                                        variant='outlined'
                                                        className='borderRadiusFlat borderWidth2 buttonPaddingY10'
                                                        sx={{ borderColor: 'text.primary', height: '50px', fontSize: '18px', boxShadow: 'none' }}
                                                    >
                                                        {t('learn_more')}
                                                    </Button>
                                                </Grid>
                                            }

                                        </Grid>
                                    </Grid>
                                    <Grid
                                        size={12}
                                        sx={{
                                            position: 'absolute',
                                            top: 0,
                                            right: 0,
                                            width: { md: '100%', xs: '100%' },
                                            height: '100%',
                                            backgroundImage: `url("${slider?.imageUrl}")`,
                                            backgroundRepeat: 'no-repeat',
                                            backgroundSize: 'cover',
                                            backgroundPositionX: { md: 'unset', xs: '100%' }
                                        }}
                                    >
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box sx={{ height: '100%', width: '100%', marginX: 'auto', display: { lg: 'none', xs: 'flex' }, justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
                                <Grid container spacing={4} sx={{ zIndex: 1, width: '100%' }}>
                                    <Grid size={12} sx={{ height: '400px' }}>
                                        <Box component={'img'} src={slider?.imageUrl} height={1} width={1} className='fitCover' />
                                    </Grid>
                                    <Grid container spacing={4} sx={{ zIndex: 1, width: { md: '85%', xs: '90%' }, mx: 'auto' }}>
                                        <Grid size={12} zIndex={2}>
                                            <Grid container spacing={2}>
                                                <Grid size={12}>
                                                    <Typography variant="h1" component={'h1'} fontSize={{ md: '64px', xs: '2rem' }} color='text.secondary' fontWeight={'bold'} fontFamily={'DanmarkURW'}>
                                                        {slider?.title}
                                                    </Typography>
                                                </Grid>
                                                <Grid size={12}>
                                                    <Typography variant="body1" component={'p'} fontSize={{ md: '24px', xs: '16px' }} color='text.secondary' sx={{ whiteSpace: 'pre-wrap' }}>
                                                        {slider?.description}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid size={{ md: 4, xs: 12 }} zIndex={2}>
                                            <Grid container spacing={2}>
                                                <Grid size={{ md: 6, xs: 12 }}>
                                                    <Button
                                                        fullWidth
                                                        component={Link}
                                                        to={`https://wa.me/+383049909090?text=${encodeURIComponent(slider.bookUrl)}`}
                                                        target="_blank"
                                                        variant='contained'
                                                        className='borderRadiusFlat borderWidth2 buttonPaddingY10 placeBorder'
                                                        sx={{ borderColor: 'text.primary', height: '50px', fontSize: '18px', boxShadow: 'none', border: 'solid 1px #1e353d' }}
                                                    >
                                                        {t('book_now')}
                                                    </Button>
                                                </Grid>
                                                {
                                                    slider.learnUrl &&
                                                    <Grid size={{ md: 6, xs: 12 }}>
                                                        <Button
                                                            fullWidth
                                                            component={Link}
                                                            to={slider.learnUrl}
                                                            variant='outlined'
                                                            className='borderRadiusFlat borderWidth2 buttonPaddingY10'
                                                            sx={{ borderColor: 'text.primary', height: '50px', fontSize: '18px', boxShadow: 'none', bgcolor: '#1e353d' }}
                                                        >
                                                            {t('learn_more')}
                                                        </Button>
                                                    </Grid>
                                                }

                                            </Grid>
                                        </Grid>
                                    </Grid>

                                </Grid>

                            </Box>

                        </Box>
                    </SwiperSlide>
                ))
            }
        </Swiper>
    );
}